export default {
  methods: {
    premission(code) {
      const premissionsStr = sessionStorage.getItem("permission");
      // console.log(premissionsStr);
      if (
        !premissionsStr ||
        premissionsStr == undefined ||
        premissionsStr == null
      ) {
        return false;
      }

      const premissions = JSON.parse(premissionsStr);
      if (premissionsStr == '["*:*:*"]') {
        return true;
      }
      return premissions.findIndex(x => x == code) != -1;
    }
  }
};
